
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M2.06008 10.06C2.57008 10.57 3.38008 10.62 3.93008 10.16C8.60008 6.31999 15.3801 6.31999 20.0601 10.15C20.6201 10.61 21.4401 10.57 21.9501 10.06C22.5401 9.46999 22.5001 8.48999 21.8501 7.95999C16.1401 3.28999 7.88008 3.28999 2.16008 7.95999C1.51008 8.47999 1.46008 9.45999 2.06008 10.06ZM9.82008 17.82L11.2901 19.29C11.6801 19.68 12.3101 19.68 12.7001 19.29L14.1701 17.82C14.6401 17.35 14.5401 16.54 13.9401 16.23C12.7201 15.6 11.2601 15.6 10.0301 16.23C9.46008 16.54 9.35008 17.35 9.82008 17.82ZM6.09008 14.09C6.58008 14.58 7.35008 14.63 7.92008 14.22C10.3601 12.49 13.6401 12.49 16.0801 14.22C16.6501 14.62 17.4201 14.58 17.9101 14.09L17.9201 14.08C18.5201 13.48 18.4801 12.46 17.7901 11.97C14.3501 9.47999 9.66008 9.47999 6.21008 11.97C5.52008 12.47 5.48008 13.48 6.09008 14.09Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-wifi`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconWifi

    ```js
    <b-new-b-icon-wifi />
    ```
</docs>


